export enum EventENUM {
  RBO_USER_SIGNUP = "rbo user signup",
  RBO_USER_LOGIN = "rbo user login",
  RBO_PROFILE_COMPLETED = "rbo profile completed",
  RBO_ONBOARDING_EXIT = "rbo onboarding exit",
  RBO_AIRBNB_PROFILE_CONNECTED = "rbo airbnb profile connected",
  RBO_PROFILE_ERROR = "rbo profile error",
  RBO_PROPERTY_ADDED = "rbo property added",
  RBO_PROPERTY_SYNC_STARTED = "rbo property sync started",
  RBO_PROPERTY_SYNC_COMPLETED = "rbo property sync completed",
  RBO_PROPERTY_EDITED = "rbo property edited",
  RBO_PRICING_UPDATED = "rbo pricing updated",
  RBO_AVAILABILITY_BLOCKED = "rbo availability blocked",
  RBO_AVAILABILITY_UNBLOCKED = "rbo availability unblocked",
  RBO_DASHBOARD_VISIT = "rbo dashboard visit",
  RBO_SUPPORT_CLICKED = "rbo support clicked",
  RBO_USER_LOGOUT = "rbo user logout",
}
